import React from 'react';
import './Contact.css';

const Contact = () => {
  return (
    <section className="contact-section">
      <div className="contact-container">
        <h2 className="section-title">Get in Touch</h2>
        <div className="contact-content">
          <div className="contact-info">
            <h3>We'd love to hear from you!</h3>
            <p>
              Whether you're interested in renting a bicycle, purchasing one, or learning more about our 
              sustainability initiatives, we're here to help. Reach out to us through any of the following channels:
            </p>
          </div>
          
          <div className="contact-visual">
            <div className="contact-card">
              <h3>Buy Our Cycles</h3>
              <p>
                  <strong>RePedal</strong> <br />
                  In front of GESH Office <br />
                  In front of CSRE,
                  IIT Bombay, Powai<br />
                  Mumbai - 400076<br />
                  Maharashtra, India <br/>
                </p>
            </div>
            
            <div className="contact-card">
              <h3>Give us a call before arriving</h3>
              <p>
                  <strong>Sreejesh</strong><br />
                  Phone: +91 9512535642<br />
                  OR <br/>
                  <strong>Ritesh Kumar</strong><br />
                  Email: riteshkumarcontact@gmail.com<br />
                  Phone: +91 9479907541<br />
              </p>
            </div>
            
            <div className="contact-card">
              <h3>Visit Our Office</h3>
               <p>
                  <strong>GESH Office, </strong> 2nd Floor, <br />
                  Old CESE Building <br />
                  IIT Bombay, Powai<br />
                  Mumbai - 400076<br />
                  Maharashtra, India <br/>
                  Office Hours: <br />
                  Mon-Fri, 10:00 AM - 6:00 PM
                </p>
            </div>
          </div>
          
          {/* Map Section */}
          <div className="map-section">
            <h3>Find Us Here</h3>
            <div className="map-container">
              {/* <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3769.8636!2d72.9149!3d19.1334!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c7d1b5b6b6b5%3A0x1b6b6b6b6b6b6b6b!2sIIT%20Bombay%2C%20Powai!5e0!3m2!1sen!2sin!4v1234567890!5m2!1sen!2sin"
                width="100%"
                height="300"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="IIT Bombay Location"
              ></iframe> */}
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d881.7073402757212!2d72.91727453165434!3d19.132087670577604!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c792dab04f4f%3A0xe3eef52ab420f91f!2sCentre%20for%20Urban%20Science%20and%20Engineering!5e0!3m2!1sen!2sin!4v1753177609997!5m2!1sen!2sin" 
              width="100%"
              height="300"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="GESH IITB Location"></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;